import { COUNSELING_CENTER_ERROR, COUNSELING_CENTER_RECEIVE, COUNSELING_CENTER_REQUEST } from './CounselingCenterAction'

const initialState = {
	id: null,
	username: '',
	title: '',
	description: '',
	profile_url: null,
	consultants: [],
	timeZone:'',
	currency:'',
	language:'',


}

const CounselingCenterReducer = (state = initialState, action = {}) => {
	const { type, counselingCenter, error } = action

	switch (type) {
		// ------------------------------------ counselingCenter fetch ------------------------------------
		case COUNSELING_CENTER_REQUEST:
			return {
				...state,
				isCounselingCenterFetching: true
			}
		case COUNSELING_CENTER_RECEIVE:
			return {
				...state,
				isCounselingCenterFetching: false,
				...counselingCenter
			}
		case COUNSELING_CENTER_ERROR:
			return {
				...state,
				isCounselingCenterFetching: false,
				error
			}

		default:
			return state
	}
}

export default CounselingCenterReducer
